import * as React from "react";
import styled from "styled-components";
import { ConferenceInterface, getConferenceStatusCN } from "@/types";
import { Button } from "antd";

const Container = styled.div`
  width: 400px;
  .atitle {
    height: 40px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    padding-top: 15px;
  }
  .item {
    display: flex;
    align-items: center;
    margin-top: 25px;
    .l {
      width: 200px;
    }
  }
`;

interface AppointPreviewProp {
  conference: ConferenceInterface;
  onClose: () => void;
  onDelete: (roomId: string, operation: string) => void;
}

const AppointPreview: React.FC<AppointPreviewProp> = ({
  conference,
  onClose,
  onDelete,
}) => {
  const okHandler = () => {
    onDelete(conference.roomId, "delete");
  };

  return !conference ? (
    <></>
  ) : (
    <div
      className="modal f jc"
      // okText="删除"
      // cancelText="返回"
      // onOk={okHandler}
      // onCancel={onClose}
      // visible={!!conference}
      // centered
      // width={450}
    >
      <Container>
        <div className="atitle mt30 jsc">Уулзалтын мэдээлэл</div>
        <div className="item mt25">
          <div>{conference.title}</div>
        </div>
        <div className="item">
          <span className="l">Эхлэх цаг</span>
          <span>{conference.beginTime}</span>
        </div>
        <div className="item">
          <span className="l">Дуусах цаг</span>
          <span>{conference.endTime}</span>
        </div>
        <div className="item">
          <span className="l">Цагийн бүс</span>
          <span>Улаанбааатар</span>
        </div>
        <div className="item">
          <span className="l">Нийт хугацаа</span>
          <span>{conference.duration}</span>
        </div>
        <div className="item">
          <span className="l">Уулзалтын ID</span>
          <span>{conference.conferenceNo}</span>
        </div>
        <div className="item">
          <span className="l">Үүсгэсэн хүн</span>
          <span>{conference.ownerName}</span>
        </div>
        <div className="item">
          <span className="l">Уулзалтын төрөл</span>
          <span>{ conference.type}</span>
        </div>
        <div className="item">
          <span className="l">Уулзалтын төрөл</span>
          <span>{getConferenceStatusCN(conference.status)}</span>
        </div>
        <div className="mt40 jssb">
          {/* <Button className="w160" type="primary" danger onClick={okHandler}>
            删除
          </Button> */}
          <Button className="w160" onClick={onClose}>
            Буцах
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default AppointPreview;
